import React, { FC } from 'react'
import { QuantityLimitationForm, QuantityLimitationTable } from '../components';

export const QuantityLimitationPage: FC = () => (<QuantityLimitationTable />);


export const QuantityLimitationFormPage: FC = () => (<QuantityLimitationForm />);